import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const ordersIndex = lazyWithRetry(() => import("./routes/index"));
const orderCreate = lazyWithRetry(() => import("./routes/create"));
const orderDetail = lazyWithRetry(() => import("./routes/[id]/index"));

const orderCreateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/orders/create",
  component: () =>
    renderProtectedRoute(orderCreate, { requirePerms: ["orders:write"] }),
});

const ordersIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/orders",
  beforeLoad: () => ({
    breadcrumbs: [{ label: "Dashboard", to: "/" }, { label: "Orders" }],
  }),
  component: () =>
    renderProtectedRoute(ordersIndex, { requirePerms: ["orders:read"] }),
});

const orderDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/orders/$id",
  component: () =>
    renderProtectedRoute(orderDetail, { requirePerms: ["orders:read"] }),
});

export const ordersRouteTree = [
  orderCreateRoute,
  ordersIndexRoute,
  orderDetailRoute,
];
